import React from "react";

const Bold = (props) => {
  return (
    <div>
      <p>
        {props.boldWords.map((boldWord, index) => {
          return (
            <span key={boldWord}>
              {props.beforeContent[index]}
              <strong key={index}>{boldWord}</strong>
              {props.afterContent[index]}
            </span>
          )
        })}
      </p>
    </div>
  );
};
export default Bold;